import type { ReactNode } from 'react';
import s from './SectionHeader.module.scss';

// ── 섹션 헤더(재사용 원본 1개) ───────────────────────────────────────
//   배경/근거: h2 제목 스타일($h2-size/400/-2px/ink-dark)이 6개 섹션에 반복 + .head(flex) 구조가
//   News·Solutions 동일, Trust 는 제목+태그라인+divider(split) → 하나로 파라미터화(2026-07-31).
//   렌더 분기:
//     · tagline 있음 → split 레이아웃(제목 | 태그라인) + (옵션)divider   [Trust]
//     · tagline 없음 → flex 헤더(제목 + 우측 actions)                    [News·Solutions·Spotlight·Products·Services]
//   dark=true → 어두운 섹션용 흰 제목(Products navy 섹션).
//   className → root 병합(섹션별 여백/애니메이션(anim-scroll) 덧입힘).
//   ★제외: Instruments 는 제목+aside(desc/cta) 2단 그리드라 이 컴포넌트 미사용(커스텀 유지).
//     단 제목 폰트 스펙은 2-⑥(2026-09-05)에서 $h2-size/-2px 로 통일 — 크기는 여기와 동일, 레이아웃만 다름.
type Props = {
  title: ReactNode;
  tagline?: string;
  actions?: ReactNode;
  divider?: boolean;
  dark?: boolean;
  className?: string;
};

export default function SectionHeader({ title, tagline, actions, divider, dark, className }: Props) {
  const titleCls = [s.title, dark ? s.dark : ''].filter(Boolean).join(' ');

  if (tagline !== undefined) {
    return (
      <>
        <div className={[s.split, className].filter(Boolean).join(' ')}>
          <h2 className={titleCls}>{title}</h2>
          <p className={s.tag}>{tagline}</p>
        </div>
        {divider && <div className={s.divider} />}
      </>
    );
  }

  return (
    <div className={[s.head, className].filter(Boolean).join(' ')}>
      <h2 className={titleCls}>{title}</h2>
      {actions && <div className={s.actions}>{actions}</div>}
    </div>
  );
}
